import { reactive, toRefs, onMounted, watchEffect, watch, nextTick, computed, ref } from 'vue'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'

import { getCategoryList, getTopCategoryList } from '@/api/directSales'
import { setSession, getSession, getDistance } from '@/util'
import { getDealers } from '@/api/plan'
import { showToast } from '@/util/couponCollection'
export const getDealerDetailByGscode = async data => {
  const store = useStore()
  try {
    // console.log('getDealerDetailByGscode--', data)
    let { lat, lng } = store.state.position
    let { list = [] } = await getDealers({
      gsCode: data.gsCode,
      latitude: lat,
      longitude: lng
    })
    const dealerInfo = list[0] || {}
    dealerInfo.distance = getDistance(dealerInfo.distance)
    let _gsCode = dealerInfo.gs_code || dealerInfo.gsCode
    dealerInfo.gs_code = dealerInfo.gsCode = _gsCode
    store.dispatch('setLoyaltyDealerInfo', dealerInfo)
  } catch (e) {
    // showToast(e.message, '获取经销商详情失败')
    // store.dispatch('setLoyaltyDealerInfo', {})
  }
}

export default function useConditionFn() {
  const store = useStore()
  const route = useRoute()
  const popUpRef = ref()
  const router = useRouter()
  const canScrollToActive = false
  const state = reactive({
    menuPopUpListData: [],
    menuList: [],
    conditionList: [
      { label: '综合排序', id: 'complex', disable: false },
      { label: '销量', id: 'salescount', disable: false },
      { label: '价格', id: 'price', sort: true, sortKey: 'price', direction: 'desc', disable: false }
    ],
    showMenuListNum: 0,
    menuRes: { name: '全部', identifier: 'all' },
    menuPopUpRes: [],
    conditionRes: {}
  })
  watchEffect(() => {
    const getDisableStatus = item => {
      let carId = store.state.currentCarInfo?.id || ''
      let menu = state.menuRes.identifier
      let disable = false
      // 选择全部，销量排序：置灰
      if (menu === 'all' && item.id === 'salescount') {
        if (state.conditionRes?.id === item.id) {
          state.conditionRes = state.conditionList.find(condition => condition.id === 'complex')
        }
        disable = true
      }
      // 无车辆信息，价格置灰
      if (!carId && item.id === 'price') {
        if (state.conditionRes?.id === item.id) {
          state.conditionRes = state.conditionList.find(condition => condition.id === 'complex')
        }
        disable = true
      }
      // console.log('getDisableStatus', menu, item, disable)
      return disable
    }
    state.conditionList = state.conditionList.map(item => {
      return {
        ...item,
        disable: getDisableStatus(item)
      }
    })
    // }
  })
  const getCategoryListFn = async () => {
    try {
      state.menuPopUpListData = []
      let data = await getCategoryList()
      state.menuPopUpListData = data
    } catch (error) {
      state.menuPopUpListData = []
    }
  }
  const getMenuListFn = async () => {
    try {
      state.menuList = []
      let data = await getTopCategoryList()
      state.menuList = data.map(({ name, identifier }) => ({ name, identifier }))
      // state.menuList = [
      //   { label: '全部', id: '0' },
      //   { label: '原厂保养套餐', id: '1' },
      //   { label: '原厂延保套餐', id: '2' },
      //   { label: '选购轮胎', id: '3' },
      //   { label: '致友计划', id: '4' }
      // ]
    } catch (error) {
      state.menuList = []
    } finally {
      initMenu()
    }
  }
  const setVal = (key, val) => {
    try {
      state[key] && (state[key] = val)
    } catch (error) {
      console.error('setVal error', error)
    }
  }
  const changeMenuSelect = data => {
    // console.log('changeMenuSelect---condition', data)
    if (data.btnId === 'sure') {
      popUpRef.value.closePopUp()
      const selectMenuItemSession = getSession('selectShopMenuItem')
      state.menuPopUpRes = getSelectShopMenuItemRes(selectMenuItemSession)
      // state.menuRes = { name: '全部', identifier: 'all' }
      state.menuRes = { name: '', identifier: '' }
    }
  }

  const selectCondition = data => {
    if (data.disable) {
      return
    }
    state.conditionRes = data
  }
  const changeSort = data => {
    if (data.disable) {
      return
    }
    let index = state.conditionList.findIndex(item => item.id === data.id)
    if (index > -1) {
      let select = { ...data, direction: data.direction === 'desc' ? 'asc' : 'desc' }
      state.conditionList[index] = select
      state.conditionRes = select
    }
  }
  const getSelectShopMenuItemRes = data => {
    // return data
    //   .map(item => (item.en === 'all' ? getSelectShopMenuItemRes(item.child) : item.id))
    //   .flat(Infinity)
    return data.map(item => (item.en === 'all' ? item.pid : item.identifier))
  }
  // 横向菜单
  const selectMenu = data => {
    // console.log('selectMenu', data)
    state.menuRes = data
    state.menuPopUpRes = []
    setSession('selectShopMenuItem', [])
    store.commit('SETSELECTSHOPMENUITEM', [])
  }
  const showMenuListNumFn = () => {
    let selectShopMenuItem = getSession('selectShopMenuItem')
    store.commit('SETSELECTSHOPMENUITEM', [...selectShopMenuItem])
    state.showMenuListNum += 1
  }
  const scrollToActive = () => {
    nextTick(() => {
      let currentIdentifier = state.menuRes?.identifier
      if (currentIdentifier) {
        let currentEl = document.getElementById(currentIdentifier)
        let positionX = currentEl.getBoundingClientRect().left + document.documentElement.scrollLeft
        // console.log('positionX--', positionX)
        let mainContainerEl = document.getElementById('mainContainer')
        mainContainerEl.scrollLeft = positionX - 30
      }
    })
  }
  const initMenu = () => {
    let { categoryCode = '' } = route.query
    let param = getSession('shopListParam') || {}
    let { menuRes, conditionRes } = param
    state.menuRes = menuRes || { name: '全部', identifier: 'all' }
    if (categoryCode) {
      selectMenu({ identifier: categoryCode })
      nextTick(() => {
        router.push({ query: { ...route.query, categoryCode: '' } })
      })
    }
    state.conditionRes = conditionRes || { label: '综合排序', id: 'complex' }
    const selectMenuItemSession = getSession('selectShopMenuItem') || []
    state.menuPopUpRes = getSelectShopMenuItemRes(selectMenuItemSession)
    nextTick(() => {
      canScrollToActive && scrollToActive()
    })
  }
  onMounted(async () => {
    getCategoryListFn()
    getMenuListFn()
  })

  return {
    ...toRefs(state),
    setVal,
    selectMenu,
    changeSort,
    changeMenuSelect,
    selectCondition,
    showMenuListNumFn,
    popUpRef
  }
}
